import IShopTile from "../Abstraction/IShopTile";
// Shop tiles images
import tile1 from '../Assets/dataImages/shopTiles/tile-1.png';
import tile2 from '../Assets/dataImages/shopTiles/tile-2.png';
import tile3 from '../Assets/dataImages/shopTiles/tile-3.png';
import tile4 from '../Assets/dataImages/shopTiles/tile-4.png';
import tile5 from '../Assets/dataImages/shopTiles/tile-5.png';
import tile6 from '../Assets/dataImages/shopTiles/tile-6.png';
import tile7 from '../Assets/dataImages/shopTiles/tile-7.png';
import tile8 from '../Assets/dataImages/shopTiles/tile-8.png';
import tile9 from '../Assets/dataImages/shopTiles/tile-9.png';

export const shopTiles:IShopTile[] = [
    {
        id: 1,
        image: tile1
    },
    {
        id: 2,
        image: tile2
    },
    {
        id: 3,
        image: tile3
    },
    {
        id: 4,
        image: tile4
    },
    {
        id: 5,
        image: tile5
    },
    {
        id: 6,
        image: tile6
    },
    {
        id: 7,
        image: tile7
    },
    {
        id: 8,
        image: tile8
    },
    {
        id: 9,
        image: tile9
    },
]